import React, { useEffect, useMemo, useState } from 'react';
import {  Select } from 'antd';
import { PLATFORM_ID } from 'utils/constants';

const PLATFORM_ID_TO_RAM_GIB_LIST = {
  [PLATFORM_ID.ANDROID]: [1, 2, 3, 4, 6, 8, 10, 12, 14, 16],
  [PLATFORM_ID.IOS]: [1, 2, 3, 4, 6, 8, 16],
};

const RamGibSelect = ({
  platformId,
  value,
  onChange,
  /**
   * 可选。提供时，多选变化不会逐次触发，而是等下拉框关闭后才触发一次（用法对齐 CountrySelect/UserSceneTagSelect
   * 的 onChangeWhenDropdownClosed），避免多选过程中连续刷新调用方的数据。不提供则保持原有的即时触发行为（onChange）。
   */
  onChangeWhenDropdownClosed,
  placeholder,
}) => {
  const options = useMemo(() => {
    return (PLATFORM_ID_TO_RAM_GIB_LIST[platformId] || [])
      .map(x => ({ label: `${x} GiB`, value: x }));
  }, [platformId]);

  const deferUntilDropdownClosed = !!onChangeWhenDropdownClosed;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [intermediateValue, setIntermediateValue] = useState(value);

  useEffect(() => {
    setIntermediateValue(value);
  }, [value]);

  return <Select
    style={{ width: '100%' }}
    mode='multiple'
    allowClear={true}
    showArrow={true}
    placeholder={placeholder}
    options={options}
    value={deferUntilDropdownClosed ? intermediateValue : value}
    onChange={v => {
      if (!deferUntilDropdownClosed) {
        onChange(v);
        return;
      }
      if (dropdownOpen) {
        setIntermediateValue(v);
      } else {
        // 下拉框关闭状态下也可能触发 onChange（例如点击 allowClear 的清空按钮），这种情况不会经过
        // onDropdownVisibleChange，必须在这里直接提交，否则清空操作会被"吞掉"（对齐 CountrySelect/UserSceneTagSelect 的写法）。
        onChangeWhenDropdownClosed(v);
      }
    }}
    {...(deferUntilDropdownClosed ? {
      onDropdownVisibleChange: open => {
        setDropdownOpen(open);
        if (open) {
          setIntermediateValue(value);
        } else if (value !== intermediateValue) {
          onChangeWhenDropdownClosed(intermediateValue);
        }
      },
    } : {})}
  />
};

export default RamGibSelect;
